const state = {
    user: {
        name:'',
        id:''
    },
    baseUrl:'http://api-test.guojiangwine.cn',
	// baseUrl:'http://jxapi-test.cvddr.cn'
	channel:[
		{name:"国匠酒业",value:1},
		{name:"国华酒业",value:2},
		{name:"国优酒业",value:3},
	],
};

export default state;



// WEBPACK FOOTER //
// ./src/store/state.js